import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardHeaderBarComponent } from './dashboard-header-bar.component';

@NgModule({
   declarations: [DashboardHeaderBarComponent],
   exports: [DashboardHeaderBarComponent],
   imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
})
export class DashboardHeaderBarModule {}
